module.exports = __webpack_public_path__ + "files/RICAI2021.292447eff53308ee57a52e6645e9e130.pdf";